export interface CampaignPage {
  ref: string;
  marketCode: string;
  slug: string;
  name: string;
  kind: 'seasonal' | 'theme' | 'brand';
  status: 'draft' | 'live';
  startsAt: string;
  endsAt: string;
  intro: string;
  advice: string;
  timeline: { label: string; date: string }[];
  faq: { question: string; answer: string }[];
  merchants: { ref: string; slug: string; name: string }[];
  issues: string[];
  canEdit: boolean;
}

export type WidgetType = 'hero_carousel' | 'featured_merchants' | 'top_codes' | 'banner' | 'text';
export type PageType = 'home' | 'category' | 'campaign' | 'merchant';
export type Region = 'top' | 'middle' | 'bottom' | 'sidebar';

export interface WidgetLink {
  kind: 'merchant' | 'coupon' | 'campaign' | 'category' | 'url';
  slug?: string;
  ref?: string;
  url?: string;
}

export interface WidgetPlacement {
  ref: string;
  siteRef: string;
  siteName: string;
  pageType: PageType;
  region: Region;
  targets: { categories?: string[]; merchants?: string[]; campaigns?: string[] };
  position: number;
  startsAt: string | null;
  endsAt: string | null;
  sponsoredBy: string | null;
  state: 'scheduled' | 'live' | 'ended';
  canEdit: boolean;
}

export interface Widget {
  ref: string;
  organizationRef: string;
  type: WidgetType;
  name: string;
  config: Record<string, unknown>;
  status: 'draft' | 'approved';
  placements: WidgetPlacement[];
  canEdit: boolean;
  updatedAt: string;
}

export interface WidgetOptions {
  types: WidgetType[];
  pageTypes: PageType[];
  regionsByPage: Record<PageType, Region[]>;
  merchantPageTypes: WidgetType[];
}

export const WIDGET_LABELS: Record<WidgetType, string> = {
  hero_carousel: 'Hero carousel',
  featured_merchants: 'Featured stores',
  top_codes: 'Top codes',
  banner: 'Banner',
  text: 'Text and FAQ',
};

export const PAGE_LABELS: Record<PageType, string> = { home: 'Homepage', category: 'Category pages', campaign: 'Campaign pages', merchant: 'Merchant pages' };

/** "a, b , c" → ["a","b","c"] */
export const splitList = (value: string): string[] =>
  value
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
